import { FormGroupName } from '@angular/forms';
import { Component, OnInit, Input, Output } from '@angular/core';

import { FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';

import { FormPackage } from '../../models/df-package';

@Component({
	selector: 'df-number-box',
	templateUrl: './number-box.component.html',
	styleUrls: ['./number-box.component.scss']
})
export class NumberBoxComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() form: FormGroup;
	@Input() config: FormGroup;
	constructor() {}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit(): void {}
}
